(function() {
	'use strict';

	angular
		.module('app.setup')
		.controller('projectStages', projectStages);

	projectStages.$inject = ['$rootScope', '$scope', '$filter', '$timeout',
		'$compile', '$uibModal', 'projectStagesService', 'leanProjectsService', 'storeService'];

	function projectStages($rootScope, $scope, $filter, $timeout, $compile,
			$uibModal, projectStagesService, leanProjectsService, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;

		// var pageLoaded = false;
		vm.actualSavingsOptions = [
			{name: 'All Projects', value: false},
			{name: 'Approved Projects Only', value: true}
		];

		vm.sortableOptions = {
			connectWith: ['.sortable-container'],
			items: 'div.editable:not(.new)',
			stop: updateSequence
		};

		vm.addStage = addStage;
		vm.removeStage = removeStage;
		vm.cancelEdits = cancelEdits;
		vm.saveEdits = saveEdits;
		vm.startEditing = startEditing;

		vm.stageBackups = {};

		init();

		function init() {
			leanProjectsService.getStages(adminConfig.factory.id)
			.then(function initStages(stages) {
				vm.stages = stages;
				for (var i = 0; i < vm.stages.length; i++) {
					vm.stages[i].editable = (
						vm.stages[i].stageSequence !== -1 &&
						vm.stages[i].stageSequence !== 1000);
					vm.stages[i].editing = false;
					vm.stages[i].weight = parseFloat((vm.stages[i].weight * 100).toFixed(1));
				}
			});
		}

		function addStage () {
			vm.stages.push({
				name: '',
				code: '',
				description: '',
				weight: 100,
				stageSequence: vm.stages.length - 2,
				editable: true,
				editing: true,
				new: true
			});

			vm.stages.sort(function sortStages(a, b) {
				return a.stageSequence - b.stageSequence;
			});
		}

		function startEditing(stage) {
			stage.editing = true;
			vm.stageBackups[stage.id] = {
				name: stage.name,
				code: stage.code,
				description: stage.description,
				weight: stage.weight
			};
		}

		function cancelEdits(stage, index) {
			if (stage.new) {
				vm.stages.splice(index, 1);
			} else {
				var savedStage = vm.stageBackups[stage.id];
				stage.name = savedStage.name;
				stage.code = savedStage.code;
				stage.description = savedStage.description;
				stage.editing = false;
			}
		}

		function removeStage(stage) {
			var confirmScope = $scope.$new();
			confirmScope.additionalText = 'delete this stage';
			confirmScope.buttonText = 'Delete';
			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/core/confirm.html'
			};

			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function() {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function() {
				instance.close();
				confirmScope.$destroy();

				projectStagesService.deleteStage(stage.id, adminConfig.factory.id)
					.then(function stageDeleted(response) {
						if (response.status === 200) {
							// remove stage from model
							for (var i = 0; i < vm.stages.length; i++) {
								if (vm.stages[i].id === stage.id) {
									vm.stages.splice(i, 1);
									break;
								}
							}
							$rootScope.$emit('toast', {
								'message': 'Stage deleted',
								'success': true
							});
						}
					})
					.catch(function stageNotDeleted(error) {
						$rootScope.$emit('toast', {
							'message': 'Stage not deleted. Move all projects off of this stage and try again',
							'success': false,
							'time': 10000
						});
					});
			};
		}

		function updateSequence(event, ui) {
			if (ui.item.sortable.dropindex) {
				var updatedSequence = [];
				var newSequence = 0;
				for (var i = 0; i < vm.stages.length; i++) {
					var stage = vm.stages[i];
					if (stage.editable) {
						updatedSequence.push(stage.id);
						stage.stageSequence = newSequence;
						newSequence += 1;
					}
				}
				projectStagesService.updateSequence(updatedSequence, adminConfig.factory.id)
				.then(function toastNewSequence() {
					$rootScope.$emit('toast', {
						'message': 'Stage order updated',
						'success': true
					});
				});
			}
		}

		function saveEdits(stage) {
			if (validateInput(stage)) {
				if (stage.new) {
					stage.new = false;
					stage.id = projectStagesService.addStage(stage, adminConfig.factory.id)
						.then(function setStageId(response) {
							var message = 'Stage saved successfully';
							var success = true;
							if (response.status === 400 || response.status === 409 || response.status === 412) {
								message = response.data.error;
								success = false;
								removeNewlyAddedStageOnError(stage);
							} else {
								stage.id = response.data;
							}
							$rootScope.$emit('toast', {
								'message': message,
								'success': success
							});
						});
				} else {
					projectStagesService.updateStage(stage, adminConfig.factory.id)
						.then(function showToast() {
							$rootScope.$emit('toast', {
								'message': 'Stage saved successfully',
								'success': true
							});
						});
				}
				stage.editing = false;
			}
		}

		function removeNewlyAddedStageOnError(stage) {
			for (var i = 0; i < vm.stages.length; i++) {
				if (vm.stages[i].name === stage.name && vm.stages[i].code === stage.code &&
					vm.stages[i].stageSequence === stage.stageSequence) {
					vm.stages.splice(i, 1);
					break;
				}
			}
		}

		function validateInput(stage) {
			if (stage.name != null && stage.name.trim() !== '' && stage.code != null && stage.code !== '') {
				return true;
			}
			return false;
		}
	}
})();
